<template>
	<div class="informationDetails">
		<div class="header">
			<div class="foldingNav" @click="showPopup">
				<van-icon name="wap-nav" />
			</div>
			<div class="tabbar">
				<van-tabs v-model="channel_id" color="#901D22" @change="changeTabbar">
				  <van-tab v-for="(item,index) in tabbarList" :title="item.name" :key="index" :name="item.id">
				    <div class="content">
				    	<!-- 轮播图 -->
				    	<banner :type="type"></banner>
				    	<div class="articlesList">
							<row-item-list :list="articlesList"></row-item-list>	
				    	</div>
				    </div>
				  </van-tab>
				</van-tabs>
			</div>
		</div>
		<van-popup v-model="leftMenuFlag"  position="left" style="width:264px;height:100%">
			<div class="leftMenu">
				<img src="../../assets/images/User/logo.png" alt="" class="logoImg">
				<div class="hr-7"></div>
				<el-tree :data="menuList" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
			</div>
		</van-popup>
	</div>
</template>
<script>
	import Banner from "../../components/Banner";
	import RowItemList from "../../components/RowItemList";
	import {InformationChannels,InformationMenu,InformationDetails} from "../../config/interface.js";
	export default{
		components:{
			Banner,
			RowItemList,
		},
		data(){
			return{
				type:3,   				//1:专栏模块; 2:会议模块; 3:前沿资讯模块;4:病例模块;5:器械模块
				active:0,    			//当前激活的标签
				leftMenuFlag:false,     //左边菜单
				tabbarList:[],         //标签导航列表
				articlesList:[],		//文章列表
				channel_id:0,			//频道id
		        defaultProps: {
		          children: 'son',
		          label: 'name'
		        },
		        menuList:[],       //菜单列表
			}
		},
		mounted(){
			this.channel_id=this.$route.query.id;
			document.title=this.$route.query.name;
			this.getChannels();
			this.getChannelDetails();
			this.getChannelsMenu();

		},
		methods:{
			//资讯频道
			getChannels(){
				const url=InformationChannels;
				let params={};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.tabbarList=data;
						
					}
				})
			},
			//频道详情
			getChannelDetails(){
				const url=InformationDetails;
				let params={
					channel_id:this.channel_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						let readnum=data.readnum;
						let follows=data.follows;
						data.articles.forEach(function(item,index){
							item.readnum=readnum[item.id];
							item.follows=follows[item.id];
						})
						this.articlesList=data.articles;
					}
				})
			},
			//频道菜单
			getChannelsMenu(){
				const url=InformationMenu;
				let params={
					channel_id:this.channel_id
				};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.menuList=data;
						// this.roundArray([],this.oldMenuList)
					}
				})
			},
			//循环数组
			// roundArray(newMenuList,oldMenuList){
			// 	if(Array.isArray(oldMenuList)&&oldMenuList.length>0){
			// 		oldMenuList.forEach((item,index)=>{
			// 			newMenuList[index]={};
			// 			newMenuList[index].label=item.name;
			// 			newMenuList[index].id=item.id;
			// 			let arr=[];
			// 			this.roundArray(arr,item.son);
			// 			newMenuList[index].children=arr;
			// 		})
			// 	}
			// 	this.newMenuList=newMenuList;
			// },
			//改变tabbar
			changeTabbar(index){
				this.channel_id=index;
				this.getChannelDetails();
			},
			//
			showPopup(){
				this.leftMenuFlag=!this.leftMenuFlag;
			},
			//点击菜单
			handleNodeClick(item){
				console.log(item)
			},
		}
	}
</script>
<style lang="scss">
	.informationDetails{
		.header{
			border-bottom: 1px solid #BFBFBF;
			height:45px;
			background:#fff;
			.foldingNav{
				background:#fff;
				z-index:1000;
				position:absolute;
				padding:5px 10px;
				border-right:1px solid #bfbfbf;
				.van-icon{
					font-size:30px;
					color:#666;
				}
			}
			.tabbar{
				background: #F1F2F4;
				.van-ellipsis{
					font-size:14px;
					color:$color-gray;
				}
				.van-tabs--line .van-tabs__wrap{
					margin-left:52px;
				}
				.content{
					margin-top:10px;
					.articlesList{
						padding:0 12px;
						border-radius:5px;
					}
				}
			}
		}
		.leftMenu{
			img.logoImg{
				display:block;
				margin:30px auto;
				height:85px;
			}
			.el-tree-node__content{
				height:35px;
				.el-tree-node__label{
					font-size: 17px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/information/Details.vue